(() => {
  const init = () => {
    const gallery = document.querySelector('[data-pilot-gallery]');
    const viewer = document.querySelector('[data-pilot-viewer]');
    if (!gallery || !viewer || gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const data = JSON.parse(gallery.querySelector('[data-pilot-data]').textContent);
    const hero = gallery.querySelector('[data-pilot-open]');
    const heroImage = hero.querySelector('img');
    const caption = gallery.querySelector('[data-pilot-caption]');
    const thumbs = [...gallery.querySelectorAll('[data-pilot-kind]')];
    let selected = data.variants.find(v => String(v.id) === gallery.dataset.variantId) || data.variants[0];
    let kind = gallery.dataset.kind;
    const resized = (url,width) => { const value = new URL(url,location.origin); value.searchParams.set('width',width); return value.href; };
    const source = type => selected[type];
    const title = type => `${selected.title} · ${data.labels[type]}`;
    const show = type => {
      kind = type;
      const url = source(type);
      hero.href = url;
      heroImage.src = resized(url,800);
      heroImage.srcset = [390,600,800,1000,1280].map(w=>`${resized(url,w)} ${w}w`).join(', ');
      heroImage.alt = `${selected.title} - SelfEvolve Creatine Monohydrate ${data.labels[type]}`;
      caption.textContent = title(type);
      thumbs.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.pilotKind===type)));
    };
    const updateThumbs = () => thumbs.forEach(button=>{const type=button.dataset.pilotKind;{button.querySelector('img').src=resized(source(type),180);button.querySelector('img').removeAttribute('srcset');button.setAttribute('aria-label',title(type));}});
    thumbs.forEach(button=>button.addEventListener('click',()=>show(button.dataset.pilotKind)));
    document.addEventListener('variant:change',event=>{
      if(String(event.detail?.sectionId)!==gallery.dataset.sectionId)return;
      const next=data.variants.find(v=>String(v.id)===String(event.detail.variant?.id));
      if(!next)return;
      selected=next;updateThumbs();show('bottle');
    });
    updateThumbs();
    const image=viewer.querySelector('[data-pilot-viewer-image]');
    const scroll=viewer.querySelector('[data-pilot-scroll]');
    const plus=viewer.querySelector('[data-pilot-plus]');
    const minus=viewer.querySelector('[data-pilot-minus]');
    const output=viewer.querySelector('[data-pilot-level]');
    let scale=1,baseWidth=0,opener=null,oldOverflow='';
    const zoom = value => {
      const oldWidth=image.getBoundingClientRect().width||1;
      const centerX=(scroll.scrollLeft+scroll.clientWidth/2)/oldWidth;
      const centerY=(scroll.scrollTop+scroll.clientHeight/2)/(image.getBoundingClientRect().height||1);
      scale=Math.max(1,Math.min(4,value));
      image.style.width=`${Math.round(baseWidth*scale)}px`;image.style.height='auto';
      output.textContent=`${Math.round(scale*100)}%`;minus.disabled=scale===1;plus.disabled=scale===4;
      if(scale===1){scroll.scrollLeft=0;scroll.scrollTop=0;}else{scroll.scrollLeft=centerX*image.getBoundingClientRect().width-scroll.clientWidth/2;scroll.scrollTop=centerY*image.getBoundingClientRect().height-scroll.clientHeight/2;}
    };
    const fit = () => {baseWidth=Math.min(scroll.clientWidth,scroll.clientHeight*(image.naturalWidth/image.naturalHeight));zoom(1);};
    document.addEventListener('click',event=>{
      const link=event.target.closest('[data-pilot-open]');
      if(!link||!link.closest('main'))return;
      event.preventDefault();opener=link;
      image.alt=link.querySelector('img')?.alt||link.getAttribute('aria-label')||'';
      viewer.querySelector('[data-pilot-viewer-title]').textContent=image.alt;
      oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
      viewer.showModal();image.onload=fit;image.src=link.href;
      if(image.complete&&image.naturalWidth)fit();
      viewer.querySelector('[data-pilot-dismiss]').focus();
    });
    plus.addEventListener('click',()=>zoom(scale+.5));minus.addEventListener('click',()=>zoom(scale-.5));
    viewer.querySelector('[data-pilot-reset]').addEventListener('click',fit);
    viewer.querySelector('[data-pilot-dismiss]').addEventListener('click',()=>viewer.close());
    viewer.addEventListener('close',()=>{document.body.style.overflow=oldOverflow;opener?.focus({preventScroll:true});});
    window.addEventListener('resize',()=>{if(viewer.open&&image.naturalWidth)fit();});
    scroll.tabIndex=0;
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
